import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Link,
    colors
} from '@material-ui/core';

import {
    Label
} from '../../../../common';

import { PageContext } from '../PageContext';

import { ApplicationRoles } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    header: {
        color: colors.blueGrey[500],
        backgroundColor: colors.grey[200]
    },
    roleLink: {
        textDecoration: "underline",
        fontWeight: "900"

    }
}));

export const UserDetails = ({
    disabled,
    onViewOtherRole,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        user
    } = state;

    const viewOtherRoleClickHandler = (role) => {
        if (onViewOtherRole) onViewOtherRole(role);
    }

    const getRolesList = () => {
        if (user.roles && user.roles.length > 0) {
            return user.roles.map((role, index) =>
                <span key={index}>
                    <Link
                        className={classes.roleLink}
                        component="button"
                        color="textSecondary"
                        disabled={disabled}
                        onClick={() => viewOtherRoleClickHandler(role)}>
                        <Typography>
                            {role.roleName}
                        </Typography>
                    </Link>;&nbsp;
                </span>
            );
        } else {
            return "No roles assigned";
        }
    }

    const isUserAnAdmin = user && user.roles && (user.roles.find(x => x.roleName === ApplicationRoles.Administrator) !== undefined);

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardHeader
                className={classes.header}
                title={
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                User Info
                            </Typography>
                        </Grid>
                    </Grid>
                }
            />
            <CardContent>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                Display Name
                            </TableCell>
                            <TableCell>
                                {user.displayName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Assigned Roles
                            </TableCell>
                            <TableCell>
                                {getRolesList()}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                User Rights
                            </TableCell>
                            <TableCell>
                                {isUserAnAdmin ?
                                    <Label color={colors.grey[500]}>
                                        Administrators can view or manage any table
                                    </Label>
                                    :
                                    <Label color={user.isManagement ? colors.green[500] : colors.red[500]}>
                                        {user.isManagement ? "Can view or manage tables" : "Can't view or manage tables"}
                                    </Label>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Email
                            </TableCell>
                            <TableCell>
                                {user.email ? user.email : "-"}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}